import { ServicePage } from "../components/ServicePage";

const faq = [
    {
        q: "Bieten Sie feste Pflegeintervalle an?",
        a: "Ja. Viele meiner Kunden – privat wie gewerblich – buchen die Grundstückspflege im festen Rhythmus, zum Beispiel wöchentlich, vierzehntägig oder monatlich. Wir legen gemeinsam fest, was in welchem Turnus erledigt wird, danach läuft alles ohne Ihr Zutun.",
    },
    {
        q: "Was gehört alles zur Grundstückspflege?",
        a: "Je nach Bedarf: Mähen und Rasenpflege, Beetpflege und Unkrautentfernung, Hecken- und Strauchschnitt, Laubentfernung, Reinigung von Wegen und Außenflächen sowie kleine Pflegearbeiten rund ums Gebäude. Sie buchen genau das, was Ihr Grundstück braucht.",
    },
    {
        q: "Übernehmen Sie auch Gewerbe- oder Mietobjekte?",
        a: "Ja. Ich betreue auch kleinere Gewerbeflächen, Mietshäuser und Objekte von Vermietern und Hausverwaltungen im Landkreis Celle – verlässlich, mit festen Terminen und auf Wunsch regelmäßiger Abstimmung.",
    },
    {
        q: "Was kostet regelmäßige Gartenpflege in Celle?",
        a: "Das hängt von Grundstücksgröße, Leistungsumfang und Rhythmus ab. Nach einer kostenlosen Besichtigung erhalten Sie ein transparentes Festpreis-Angebot – auch für wiederkehrende Termine.",
    },
];

export const Gartenpflege = () => (
    <ServicePage
        eyebrow="Leistung · Landkreis Celle"
        h1="Gartenpflege in Celle – Ihr Grundstück in verlässlichen Händen"
        intro="Ein gepflegtes Grundstück entsteht nicht durch einzelne große Einsätze, sondern durch regelmäßige, verlässliche Pflege. Ich betreue Privatgärten, Mietobjekte und Gewerbeflächen im Landkreis Celle – von der Beetpflege über den Strauchschnitt bis zur kompletten saisonalen Grundstückspflege."
        image="/leistung-laubentfernung.webp"
        imageAlt="Gartenpflege in Celle – Julian Kosinski bei der Laubentfernung mit dem Laubbläser"
        scope={[
            "Regelmäßige Garten- und Grundstückspflege",
            "Beetpflege und Unkrautentfernung",
            "Laubentfernung im Herbst und Frühjahr",
            "Strauch- und Gehölzschnitt",
            "Zaun- und Holzpflege sowie Dachrinnenreinigung",
            "Außenreinigung rund ums Gebäude",
        ]}
        sections={[
            {
                title: "Regelmäßige Pflege für gepflegte Grundstücke",
                paragraphs: [
                    "Ob Wochengrundstück, eigener Garten oder Mietshaus: Mit festen Intervallen bleibt Ihr Grundstück dauerhaft in Ordnung. Gemäht, geschnitten, gekehrt – und die Wege bleiben frei und verkehrssicher.",
                    "Sie bekommen einen festen Ansprechpartner und feste Termine. Wenn etwas Außergewöhnliches ansteht, stimmen wir es kurz ab – unkompliziert per Telefon oder Nachricht.",
                ],
            },
            {
                title: "Saisonale Arbeiten im Gartenjahr",
                paragraphs: [
                    "Im Frühjahr steht der Neustart an: Beete vorbereiten, erste Schnitte, Wege und Flächen reinigen. Im Herbst steht vor allem die gründliche Laubentfernung im Mittelpunkt – auf Rasenflächen, Wegen und Außenanlagen, inklusive Abtransport.",
                    "Gerade Laub sollte nicht liegen bleiben: Auf Rasen führt es zu Fäulnis und kahlen Stellen, auf Wegen zur Rutschgefahr.",
                ],
            },
            {
                title: "Für Vermieter, Eigentümer und Gewerbe",
                paragraphs: [
                    "Repräsentative Außenanlagen sind die Visitenkarte jedes Gebäudes. Ich betreue auch Objekte von Vermietern, Hausverwaltungen und kleineren Gewerbebetrieben im Landkreis Celle – mit verbindlichen Terminen, sauberer Ausführung und auf Wunsch dokumentierten Ergebnissen.",
                ],
            },
        ]}
        faq={faq}
        serviceType="Gartenpflege und Grundstückspflege"
        related={[
            { to: "/heckenschnitt-celle", label: "Heckenschnitt in Celle" },
            { to: "/hochdruckreinigung-celle", label: "Hochdruckreinigung in Celle" },
            { to: "/rasenpflege-celle", label: "Rasenpflege in Celle" },
            { to: "/referenzen", label: "Referenzen ansehen" },
        ]}
    />
);
